import React, { useEffect, useState } from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import {userService, UserService} from '../../../_services';
import PropTypes from 'prop-types';
import {
  Avatar,
  Box,
  Button,
  Divider,
  Drawer,
  Hidden,
  List,
  Typography,
  makeStyles
} from '@material-ui/core';
import {
  AlertCircle as AlertCircleIcon,
  BarChart as BarChartIcon,
  Lock as LockIcon,
  Settings as SettingsIcon,
  ShoppingBag as ShoppingBagIcon,
  User as UserIcon,
  LogOut as LogOut,
  UserPlus as UserPlusIcon,
  Users as UsersIcon,
  File
} from 'react-feather';
import NavItem from './NavItem';
import { useDispatch} from 'react-redux';
import { userActions } from '../../../_actions';


const items = [
  {
    href: '/app/misTramites',
    icon: ShoppingBagIcon,
    title: 'Mis Tramites'
  }, 
  {
    href: '/app/homologacion',
    icon: File,
    title: 'Homologación de Títulos de Maestria'
  },
  {
    href: '/app/solicitud-informacion',
    icon: File,
    title: 'Solicitud de Información Estadística'
  },
   {
    href: '/app/change-password',
    icon: UserIcon,
    title: 'Cambiar Contraseña'
  }, 

  /*{
    href: '/app/customers',
    icon: File,
    title: 'Aprobación de Programas en el exterior'
  },
  {
    href: '/app/customers',
    icon: File,
    title: 'Aprobación de centros para el posgrado '
  },
  {
    href: '/app/account',
    icon: UserIcon,
    title: 'Perfil'
  },
 */
];

const useStyles = makeStyles(() => ({
  mobileDrawer: {
    width: 256
  },
  desktopDrawer: {
    width: 256,
    top: 64,
    height: 'calc(100% - 64px)'
  },
  avatar: {
    cursor: 'pointer',
    width: 64,
    height: 64
  }
}));

const NavBar = ({ onMobileClose, openMobile }) => {
  const classes = useStyles();
  const location = useLocation();
  const [username, setUsername] = useState("");
  const dispatch = useDispatch();
  const logout = ()=>{
    console.log("llego");
    dispatch(userActions.logout());
    window.location = "/";
  }

const user = {
  avatar: '/static/jose.pnm',
  jobTitle: '',
  name: username
};

  useEffect(() => {
    if (openMobile && onMobileClose) {
      onMobileClose();
    }
    let username=userService.getUserName();
    setUsername(username);
    
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  const content = (
    <Box
      height="100%"
      display="flex"
      flexDirection="column"
    >
      <Box
        alignItems="center"
        display="flex"
        flexDirection="column"
        p={2}
      >
        <Avatar
          className={classes.avatar}
          component={RouterLink}
          src={user.avatar}
          to=""
        />
        <Typography
          className={classes.name}
          color="textPrimary"
          variant="h5"
        >
          {user.name}
        </Typography>
        <Typography
          color="textSecondary"
          variant="body2"
        >
          {user.jobTitle}
        </Typography>
      </Box>
      <Divider />
      <Box p={2}>
        <List>
          {items.map((item) => (
            <NavItem
              href={item.href}
              key={item.title}
              title={item.title}
              icon={item.icon}
            />
          ))}
          <NavItem
              href=''
              key=''
              title="Salir"
              icon={LogOut}
              onClick={()=>logout()}
            />
        </List>
      </Box>
      <Box flexGrow={1} />

    </Box>
  );

  return (
    <>
      <Hidden lgUp>
        <Drawer
          anchor="left"
          classes={{ paper: classes.mobileDrawer }}
          onClose={onMobileClose}
          open={openMobile}
          variant="temporary"
        >
          {content}
        </Drawer>
      </Hidden>
      <Hidden mdDown>
        <Drawer
          anchor="left"
          classes={{ paper: classes.desktopDrawer }}
          open
          variant="persistent"
        >
          {content}
        </Drawer>
      </Hidden>
    </>
  );
};

NavBar.propTypes = {
  onMobileClose: PropTypes.func,
  openMobile: PropTypes.bool
};

NavBar.defaultProps = {
  onMobileClose: () => {},
  openMobile: false
};

export default NavBar;
